import { BaseDto } from '../../core';

export class BuyerResetPasswordDto extends BaseDto<BuyerResetPasswordDto> {
  token: string;
  newPassword: string;
  newPassworConfirm: string;
}
